import React from 'react';
import { BaasicPagerTemplate } from 'themes/components';

function BaasicPager(props) {
	return <BaasicPagerTemplate {...props} />;
}

export default BaasicPager;



// WEBPACK FOOTER //
// ./src/core/components/BaasicPager.jsx